"use client";
import { getApiToken } from "../../redux/config/configSlice";
import { initiateToken } from "../services/tokenService";
export const validateAndFetchToken = () => async (dispatch, getState) => {
  const { initToken } = getState().config;
  if (!initToken) {
    const newToken = await initiateToken();
    // Re-read before storing. PersistGate renders the app AS its loading state
    // (`loading={children}`), so pages mount with initial Redux state and fire
    // their first requests BEFORE rehydration lands. If rehydration — or a
    // login completing in another tab — restored a real token while /user/init
    // was in flight, storing the guest token here would silently downgrade an
    // authenticated session to a guest one while user.isAuthenticated stayed
    // true. That combination made booking/confirm answer -3 "Please login to
    // confirm the booking" for someone who was, by every visible sign, logged
    // in. Chrome usually won the race; slower in-app browsers (WhatsApp's
    // WebView) lost it.
    if (!getState().config.initToken) {
      dispatch(getApiToken(newToken));
    }
  }
};
